// angular
// 	.module("HeroPRO")
// 	.controller("AddLicenseController", addLicenseController);
import angular from 'angular';
import _ from 'lodash';

import './addLicense.scss';
import './businessLicense/addBusinessLicense.scss';

/* @ngInject */
export default function addLicenseController($scope, LicensesFactory, LicensesUtilityFactory, LicenseRejectReasons, LicenseTypes, LicenseIntegrationTypes, $rootScope, $window, $timeout, HPGeoStates, $uibModalInstance, raSpinnerService, LicenseAttachmentTypes, moment, activeStates, contractorId, organizationId, edit, licenseInfo) {
    let orgId = null;
    const vm = this;
    let licenseId = null;

    vm.processing = false;
    vm.states = [];
    vm.selectedState = null;
    vm.contentShown = 'addLicenseInProgress';
    vm.template = '';
    vm.contractorId = null;
    vm.licenseNumber = '';
    vm.jurisdiction = null;
    vm.integrationType = null;
    vm.expiration = null;
    vm.edit = false;
    vm.submitted = false;
    vm.fileUploaded = false;
    vm.loading = false;
    vm.errorMsg = LicenseRejectReasons.Required.Msg;
    vm.showErrorMsg = false;
    vm.isRequired = false;
    vm.action = 'ADD';
    vm.document = {
        DocumentType: LicenseAttachmentTypes.BusinessLicense,
        FileName: null,
        Key: null,
        Url: null,
    };


    init();


    vm.closeModal = function () {
        let result = false;
        if (vm.contentShown === 'addLicenseSuccess') {
            result = true;
        }
        raSpinnerService._unregister('addLicenseSpinner');
        $uibModalInstance.close(result);
    };

    vm.submitAddLicense = function () {
        addLicense();
    };

    vm.reset = function () {
        reset();
    };

    vm.validate = function () {
        if (!vm.submitted) {
            vm.showErrorMsg = false;
            return;
        }

        vm.errorMsg = getErrorMsg(LicensesUtilityFactory.validateExpirationDate(vm.expiration), LicensesUtilityFactory.isDateEmpty(vm.expiration), vm.licenseNumber, vm.jurisdiction, vm.selectedState.LicenseTypes[0].LicenseCategoryTypeId);
        vm.showErrorMsg = !LicensesUtilityFactory.validate(vm.selectedState.LicenseTypes[0], vm.licenseNumber, vm.expiration);
    };

    vm.required = function (submited, input) {
        vm.isRequired = false;
        if (!submited) {
            return vm.isRequired;
        }
        const integrationType = vm.selectedState ? vm.selectedState.LicenseTypes[0].IntegrationType : LicenseIntegrationTypes.Business;
        switch (integrationType) {
        case LicenseIntegrationTypes.Contractor:
            vm.isRequired = !!(input === null || input === '');
            break;
        default:
            vm.isRequired = false;
            break;
        }

        return vm.isRequired;
    };

    vm.uploadButtonClicked = function ($event) {
        $event.preventDefault();
    };

    vm.getLicenseType = function (state) {
        return LicensesUtilityFactory.getLicenseType(state.LicenseTypes[0].LicenseCategoryTypeId);
    };

    $scope.$on('HPFileUploaded', (evt, data) => {
        fileUploadComplete(data);
    });

    $scope.$on('HPFileRemoved', () => {
        fileRemoved();

        $timeout(() => {
            if (vm.submitted) {
                vm.errorMsg = !LicensesUtilityFactory.validateExpirationDate(vm.expiration) ? LicenseRejectReasons.ExpirationNotFuture.Msg : LicenseRejectReasons.Required.Msg;
                vm.showErrorMsg = !LicensesUtilityFactory.validate(vm.selectedState.LicenseTypes[0], vm.licenseNumber, vm.expiration);
            }
        }, 0);
    });

    /* private functions */
    function init() {
        vm.states = activeStates;
        vm.contractorId = contractorId;
        orgId = organizationId;
        vm.edit = edit;
        vm.integrationType = licenseInfo ? licenseInfo.IntegrationType : 1;

        if (edit && licenseInfo) {
            vm.action = 'SAVE';
            vm.licenseNumber = licenseInfo.LicenseNumber;
            vm.jurisdiction = licenseInfo.Jurisdiction;
            vm.integrationType = licenseInfo.IntegrationType;
            licenseId = licenseInfo.OrganizationLicenseId;

            setSelectedState(licenseInfo.StateGeoId);

            if (licenseInfo.LicenseExpireDate !== '' && licenseInfo.LicenseExpireDate !== null && angular.isDefined(licenseInfo.LicenseExpireDate)) {
                vm.expiration = moment(licenseInfo.LicenseExpireDate).format('MM-DD-YYYY');
            }
        }
    }

    function addLicense() {
        vm.processing = true;

        $rootScope.$broadcast('submitted');

        const isExistingLicense = !LicensesUtilityFactory.validateLicenseExists(vm.edit, {
            jurisdiction: vm.jurisdiction,
            licenseNumber: vm.licenseNumber,
            expiration: vm.expiration,
            stateId: vm.selectedState.StateGeoId,
            licenseTypeId: vm.selectedState.LicenseTypes[0].LicenseTypeId,
            licenseId: (licenseInfo || {}).OrganizationLicenseId || null,
        }, $scope.$resolve.licenseList);

        if (isExistingLicense) {
            vm.submitted = true;
            vm.errorMsg = LicenseRejectReasons.Duplicate.Msg;
            vm.showErrorMsg = true;
            return;
        }

        const isValidLicense = LicensesUtilityFactory.validate(vm.selectedState.LicenseTypes[0], vm.licenseNumber, vm.expiration);
        if (!isValidLicense) {
            vm.submitted = true;
            vm.errorMsg = LicenseRejectReasons.Required.Msg;

            if (vm.expiration && determineDateValidity(!LicensesUtilityFactory.validateExpirationDate(vm.expiration), vm.licenseNumber, vm.selectedState.LicenseTypes[0].LicenseCategoryTypeId)) {
                vm.errorMsg = getErrorMsg(LicensesUtilityFactory.validateExpirationDate(vm.expiration), vm.licenseNumber, vm.jurisdiction, vm.selectedState.LicenseTypes[0].IntegrationType);
            }

            vm.showErrorMsg = true;
            return;
        }

        vm.showErrorMsg = false;

        if (!vm.contractorId) {
            vm.contractorId = $scope.$resolve.contractorId;
        }

        if (edit && LicensesFactory.licenseUpdateValidation(vm.selectedState.LicenseTypes[0].LicenseTypeId)) {
            LicensesFactory.updateLicense(vm.contractorId, orgId, licenseId, vm.selectedState.LicenseTypes[0].LicenseTypeId, vm.licenseNumber, vm.expiration, vm.selectedState.LicenseTypes[0].IntegrationType, vm.jurisdiction).then(() => {
                vm.submitted = true;
                vm.contentShown = 'addLicenseSuccess';
                vm.closeModal();
            });
        } else {
            LicensesFactory.addLicense(vm.contractorId, orgId, vm.selectedState.LicenseTypes[0].LicenseTypeId, vm.licenseNumber, vm.expiration, vm.selectedState.LicenseTypes[0].IntegrationType, vm.jurisdiction).then(() => {
                vm.submitted = true;
                vm.contentShown = 'addLicenseSuccess';
                vm.closeModal();
            }, (error) => {
                if (error.status === 400) {
                    vm.submitted = true;
                    vm.errorMsg = LicenseRejectReasons.Duplicate.Msg;
                    vm.showErrorMsg = true;
                }
            });
        }
    }

    function reset() {
        vm.contractorId = null;
        vm.licenseNumber = '';
        vm.jurisdiction = null;
        vm.expiration = null;
        vm.submitted = false;
        vm.showErrorMsg = false;

        fileRemoved();

        const dropZone = $window.document.querySelector('#add-license');

        if (dropZone) {
            const scc = angular.element(dropZone).isolateScope();
            scc.resetDropzone();
        }

        $rootScope.$broadcast('reset');
    }

    function setSelectedState(stateId) {
        const index = _.findIndex(vm.states, state => state.StateGeoId === stateId);

        if (index > -1) {
            vm.selectedState = vm.states[index];
        }
    }

    function fileUploadComplete(args) {
        $timeout(() => {
            vm.document.Key = args[0].Document.DocumentId;
            vm.document.FileName = args[0].Document.CurrentVersion.Filename;
            vm.document.Url = args[0].Document.CurrentVersion.Url;
            vm.fileUploaded = true;
            // vm.loading = false;

            if (vm.submitted) {
                vm.errorMsg = !LicensesUtilityFactory.validateExpirationDate(vm.expiration) && !LicensesUtilityFactory.isDateEmpty(vm.expiration) ? LicenseRejectReasons.ExpirationNotFuture.Msg : LicenseRejectReasons.Required.Msg;
                vm.showErrorMsg = !LicensesUtilityFactory.validate(vm.selectedState.LicenseTypes[0], vm.licenseNumber, vm.expiration);
            }
        }, 0);
    }

    function fileRemoved() {
        $timeout(() => {
            vm.document.Key = null;
            vm.document.FileName = null;
            vm.document.Url = null;
            vm.fileUploaded = false;
        }, 0);
    }

    /* function setDocument(licenseType, document) {
        switch (licenseType) {
            case LicenseTypes.CSLB:
            case LicenseTypes.CILB:
                return null;
            default:
                return document;
        }
    } */

    function determineDateValidity(isExpirationInvalid, licenseNumber, licenseCategory) {
        switch (licenseCategory) {
        case LicenseTypes.Contractor:
            return isExpirationInvalid && licenseNumber;
        default:
            if (isExpirationInvalid && licenseNumber) {
                return true;
            }
            return false;
        }
    }

    /* function isDocumentEmpty(document) {
        return document.FileName === null;
    } */

    function getErrorMsg(isExpirationValid, isDateEmpty, licenseNumber, licenseCategory) {
        let required = true;
        switch (licenseCategory) {
        /* case LicenseTypes.Business:
                required = licenseNumber !== null ? false : true;
                break; */
        default:
            required = licenseNumber === null;
            break;
        }

        return required ? LicenseRejectReasons.Required.Msg : LicenseRejectReasons.ExpirationNotFuture.Msg;
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/licenses/addLicense/addLicenseController.js